import React, { useState, useEffect } from "react";

const API_URL = "https://kvrstarlightmedicalacademy.com/api/headerimage.php";
const UPLOADS_URL = "assets/logos/"; // where PHP saves files

const HeaderImageUploader = () => {
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  // Load from API
  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.filename) {
          setImagePreview(UPLOADS_URL + data.filename);
        }
      })
      .catch((err) => console.error("Fetch error:", err));
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type !== "image/jpeg") {
      alert("Only JPG images are allowed.");
      return;
    }

    setSelectedFile(file);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a JPG file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (data.filename) {
        setImagePreview(UPLOADS_URL + data.filename);
      }
      setSelectedFile(null);
    } catch (err) {
      console.error("Upload error:", err);
    }
  };

  const handleClear = async () => {
    try {
      await fetch(API_URL, { method: "DELETE" });
      setImagePreview(null);
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  return (
    <div className="container mt-4">
      <section className="content container-fluid mt-4">
        <div className="row">
          <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
            <div className="box box-primary">
              <div className="box-header with-border d-flex justify-content-between align-items-center">
                <div className="card">
                  <div className="card-body text-center">
                    <img
                      src={
                        imagePreview ||
                        "https://via.placeholder.com/2200x220?text=No+Header+Image"
                      }
                      alt="Header"
                      className="img-fluid mb-3"
                      style={{
                        width: "100%",
                        maxWidth: "2200px",
                        height: "220px",
                        objectFit: "cover",
                      }}
                    />
                    <h5 className="text-center mb-3">
                      Size Required: W 2200px × H 220px
                    </h5>

                    <input
                      type="file"
                      accept="image/jpeg"
                      className="form-control mb-3"
                      onChange={handleFileChange}
                    />

                    <button
                      className="btn btn-primary w-100 mb-3"
                      onClick={handleUpload}
                    >
                      {imagePreview ? "Replace Header Image" : "Upload Header Image"}
                    </button>

                    <button
                      className="btn btn-danger w-100"
                      onClick={handleClear}
                      disabled={!imagePreview}
                    >
                      Clear Image
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeaderImageUploader;
